import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import refreshIcon from './../Images/refreshIcon.svg';
import routerRefresh from './../Images/routerRefresh.svg';
import issueResolvedIcon from './../Images/issueResolvedIcon.svg'; // ודא שהנתיב נכון
import { getZoneFaultStatus, sendNotificationToUser, setIsSendNotificationToUser, reportDWH } from '../ZoneFaultSlice';
import { connect } from 'react-redux';
import { getMonthInHebrew } from './DateFormat';

function StatusCard(props) {
  const { cardTitle, endDate, time, statusTimeText, jobResolved, issueResolved } = props;
  const [isRotating, setIsRotating] = useState(false);

  const handleRefreshClick = async () => {
    setIsRotating(true);
    await props.getZoneFaultStatus();
    setIsRotating(false);
  };

  const handleSendNotificationClick = () => {
    props.sendNotificationToUser();
    props.reportDWH({status: 'Ongoing',messageText: 'Fault Msg Button Clicked'});
  };

  useEffect(() => {
    if (!props.isSendNotificationToUser) {
      return;
    }
  
    const FIVE_SECONDS_MS = 5 * 1000;
    const timerId = setTimeout(() => {
      props.setIsSendNotificationToUser(false);
    }, FIVE_SECONDS_MS);
  
    return () => clearTimeout(timerId);
  }, [props.isSendNotificationToUser]);

  return (
    <div className='status-card'>
      {cardTitle && (
        <div
          className='card-title'
          dangerouslySetInnerHTML={{
            __html: cardTitle,
          }}
        />
      )}
      { jobResolved ? (
        <div className={`resolved-icon ${cardTitle ? 'with-title' : ''}`}>
          <Image src={issueResolvedIcon} className='icon' />
        </div>
      ) : issueResolved ? (
        <div className={`resolved-icon ${cardTitle ? 'with-title' : ''}`}>
          <Image src={routerRefresh} className='icon' />
        </div>
      ) : ( 
        <>
          {time && (
            <div className="time">
              {endDate ? `${getMonthInHebrew(endDate)}, ${time}` : time}
            </div>
          )}
          {props.isSendNotificationToUser && 
            <div className={`send-notification-text ${props.isSuccessSendNotificationToUser ? '' : 'send-notification-text--error'}`}>
            {props.isSuccessSendNotificationToUser ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5.3931 10.9998L10.5002 15.9998L18.3931 7.99979" stroke="black" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect className='notification-error-icon-bg' width="24" height="24" rx="12"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M12 5C12.5523 5 13 5.40294 13 5.9V13.1C13 13.5971 12.5523 14 12 14C11.4477 14 11 13.5971 11 13.1L11 5.9C11 5.40294 11.4477 5 12 5Z" fill="black"/>
                <circle cx="12" cy="17.25" r="1.25" fill="black"/>
              </svg>
            )}
            {props.isSuccessSendNotificationToUser ? props.faultSendNotificationText : props.faultSendNotificationTextError}
            </div>
          }
          <div className='buttons-wrapper'>   
            {props.isDisplaySendNotificationButton && <button className='send-notification-button' onClick={handleSendNotificationClick}>תעדכנו אותי בסיום התקלה</button>}
            <button className='refresh-button' onClick={handleRefreshClick}>
              <div className={`refresh-icon ${isRotating ? 'rotating' : ''}`}>
                <Image src={refreshIcon} className='icon' alt='Refresh Icon' />
              </div>
              <div className='refresh-text'>ריענון סטטוס</div>
            </button>
          </div>
          <div className="status-update-time">{statusTimeText}</div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedProduct: state.zoneFaultBlock.selectedProduct,
    isSendNotificationToUser: state.zoneFaultBlock.isSendNotificationToUser,
    isSuccessSendNotificationToUser: state.zoneFaultBlock.isSuccessSendNotificationToUser,
    isDisplaySendNotificationButton: state.zoneFaultBlock.zoneFaultStatus?.isDisplaySendNotificationButton,
    zoneFaultStatus : state.zoneFaultBlock.zoneFaultStatus,
    isMagicLink : state.zoneFaultBlock.isMagicLink,
  };
};

const mapDispatchToProps = {
  getZoneFaultStatus,
  sendNotificationToUser,
  setIsSendNotificationToUser,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusCard);